import React, {Component} from 'react'
import {connect} from 'react-redux'
import DropboxVisual from './DropboxVisual'
import {toggleModal} from "../Actions/ToggleModal";

class DropboxNonAuth extends Component {
    constructor(props) {
        super(props);

        this.authUser = this.authUser.bind(this);
    }

    authUser(){
        this.props.toggleModal("needAuthModal")
    }


    render() {
        return (
            <div onClick={this.authUser}>
                <DropboxVisual/>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({

})

const mapActionsToProps = {
    toggleModal: toggleModal
}

export default connect(mapStateToProps, mapActionsToProps)(DropboxNonAuth)